import FieldEditor from "editor/FieldEditor";
import ContentAdminEditor from "content/adminEditors/ContentAdminEditor";


class ContentAdminEditorText extends ContentAdminEditor {

    static get_name() {
        return 'Text Input';
    }

    getInputType() {
        return '1';
    }

    /**
     * @abstract
     * @return Array
     */
    getSettingsOptions() {
        return [
            {
                name: 'slug',
                label: 'Slug',
                type: 'text'
            },
            {
                label: 'Options',
                type: 'group',
                children: [
                    {
                        name: 'optional',
                        label: 'Optional',
                        type: 'checkbox',
                        default: false
                    }
                ]
            },
            {
                name: 'type',
                label: 'Type',
                type: 'select',
                options: [{name: 'text', value: 'text', default: true}, 'tel', 'email', 'url', 'slug', 'date']
            }
        ];
    }

}

FieldEditor.register_editor('content/admin/text', ContentAdminEditorText);

export default ContentAdminEditorText;
